// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/task.css
// module id = 2552
// module chunks = 2